export default __webpack_public_path__ + "static/media/rotation.164a4e98.svg";